export enum NEW_PATIENT_LABELS {
  FIRST_NAME = 'First name',
  LAST_NAME = 'Last name',
  PHONE = 'Mobile Phone',
  LANGUAGE = 'Language',
  ROOM = 'Room',
  APPOINTMENT_TIME = 'Appointment time',
  APPOINTMENT_WITH = 'Appointment with',
  TEMPERATURE_BYPASS = 'Bypass temperature check',
  PROCEDURE = 'Procedure',
  CATEGORY = 'Category',
  TITLE = 'Title',
  COMMENTS = 'Comments',
  PATIENT_STATUS = 'Patient Status',
  STATUS = 'Status',
}
